<!-- 路由权限组件 -->
<template>
  <template v-if="hasPermission(filterParentRoutes)">
    <slot></slot>
  </template>
  <template v-else>
    <!-- 无权限时显示的占位内容 -->
    <div class="no-permission-container">
      <el-result icon="warning" :title="$t('global.noPermission')" :sub-title="$t('global.noPermissionDesc')">
        <template #extra>
          <el-button type="primary" @click="handleBack">{{ $t('global.back') }}</el-button>
        </template>
      </el-result>
    </div>
  </template>
</template>
<script setup>
import { useRoute,useRouter } from 'vue-router'
import { getAuthorizedRoutes } from '@/utils/role-permission'
import { ElResult,ElButton } from 'element-plus'

const route = useRoute()
const router = useRouter()

// 接收父组件传入的属性，用于标识是否为子路由
const props = defineProps({
  filterParentRoutes: {
    type: Array,
    default: () => []
  }
})

//判断当前路由是否子路由并且父级路由是否在过滤列表中
const isParentRouteHasPermission = (permissionName) => {

  const routeMatchedNames = route.matched.filter(item => item?.name && props.filterParentRoutes.includes(item.name.toLowerCase()))
 
  return routeMatchedNames.length > 0 && props.filterParentRoutes.includes(permissionName)

}


// 计算是否有权限访问当前路由
const hasPermission = (filterParentRoutes) => {

  if (!route.name) return false



  // 获取所有授权的路由
  const authorizedRoutes = getAuthorizedRoutes()

  const currentRouteName = route.name.toLowerCase()



  return authorizedRoutes.some(permission => {

    if (!permission.ismenu) return

    const permissionName = permission.name.toLowerCase()


    // 如果有父路由过滤列表且当前权限在列表中,直接返回true
    if (filterParentRoutes.length && isParentRouteHasPermission(permissionName)) {
      
      return true
    }

    // 如果没有父路由过滤,则比对当前路由名称
    if (!filterParentRoutes.length && currentRouteName === permissionName) {
      
      return true
    }
    
    return false
  })
}

// 返回上一页
const handleBack = () => {
  router.back()
}
</script>
<style lang="less" scoped>
.no-permission-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 60px);
  padding: 20px;
}
</style>